import { httpClient } from './httpClient';
import type { AddressTypesResponse, StatesResponse } from '../types/api';

const STATES_PATH = '/Lists/States';
const ADDRESS_TYPES_PATH = '/Lists/AddressTypes';

export async function getStates(): Promise<StatesResponse> {
  const response = await httpClient.get<StatesResponse>(STATES_PATH);
  return response.data;
}

export async function getAddressTypes(): Promise<AddressTypesResponse> {
  const response = await httpClient.get<AddressTypesResponse>(ADDRESS_TYPES_PATH);
  return response.data;
}
